import { render } from "./SocialNetwork.vue?vue&type=template&id=769759ae"
import script from "./SocialNetwork.vue?vue&type=script&scoped=true&lang=js"
export * from "./SocialNetwork.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__